import React from "react";

export default function Profile({objective, sectors, address, phone, website, indexes}) {
    const createRow = (title, content, id) => {
        return (
            <div className="ajb-grid-row stock-chip-info">
                <p className="margin-bottom-0 grey-500-text inline-block" data-testid={id}>
                    {title}
                </p>
                <p className="margin-0" data-testid={`${id}Value`}>
                    {content}
                </p>
                <hr />
            </div>
        );
    }

    const createLinks = (title, links, id, tip, size) => {
        return createRow(
            <>
                {title}&nbsp;
                <a aria-label={tip ? tip : "I'm a tooltip message"} data-balloon-length={size ? size : null} data-balloon-pos="up">
                    <i className="fas fa-question-circle tooltipped"/>
                </a>
            </>,
            <>
                {links.map( (link, i) => {
                    return (
                        <React.Fragment key={i}>
                        {link.label}
                        {i < links.length-1 ? ", ":""}
                        </React.Fragment>
                    );
                })}
            </>,
            id
        );
    }
    
    return (
        <>
            <p data-testid="profileObjectiveText">{objective}</p>
            {address !== undefined &&
                createRow(
                    'Address',
                    <>
                        {address.address1}<br/>
                        {address.address2 &&
                            <>{address.address2}<br/></>
                        }
                        {address.city}<br/>
                        {address.county &&
                            <>{address.county}<br/></>
                        }
                        {address.country}<br/>
                        {address.postCode}
                    </>,
                    'addressHeader'
                )
            }
            {phone &&
                createRow(
                    'Telephone',
                    phone,
                    'telephoneHeader'
                )
            }
            {website &&
                createRow(
                    'Website',
                    <a href={website} target="_blank" rel="noreferrer">{website}</a>,
                    'websiteHeader'
                )
            }
            {/* Display links if detected */}
            {sectors !== undefined && sectors.length > 0 &&
                createLinks('Sector', sectors, 'sector', "Shares which are in the same or similar industries are grouped together in a particular sector.", "large")
            }
            {indexes !== undefined && indexes.length > 0 &&
                createLinks('Index', indexes)
            }
        </>
    );
}